import {
  DELETE,
  POST,
  PUT,
} from "../../apiController";

const endpoint = "/admin/settings/about";

// -------------------------------------------------------- Settings About Organization

// Get organization information with pagination and search
export const getAboutOrganization = (data) => {
  return POST(endpoint, data);
};

// Add new organization information
export const addAboutOrganization = (data) => {
  return POST(endpoint + `/add`, data);
};

// Update organization information
export const updateAboutOrganization = (id, data) => {
  // Ensure id is included in both URL and body
  const updateData = {
    id: id,
    name: data.name,
    description: data.description,
  };
  return PUT(endpoint + `/${id}`, updateData);
};

// Update organization information status (active/inactive)
export const updateAboutOrganizationStatus = (id, data) => {
  return PUT(endpoint + `/status/${id}`, data);
};

// Delete organization information (soft delete)
export const deleteAboutOrganization = (id) => {
  return DELETE(endpoint + `/${id}`);
};
